import { BaseComponent } from './baseComponent';

export class Accordion extends BaseComponent {
    private titles: HTMLElement[] = [];

    constructor(container: HTMLElement, options: Record<string, any>) {
        super(container, options);

        container.querySelectorAll('.accordion').forEach(accordion => {
            const title = accordion.querySelector('.accordion-title') as HTMLElement;
            this.titles.push(title);

            title.addEventListener('keydown', this.handleKeydown.bind(this));
            title.addEventListener('click', this.toggle.bind(this));
        });

        this.onLoad();
    }

    toggle(event: MouseEvent|KeyboardEvent): void {
        event.preventDefault();
        const target: HTMLElement = event.target as HTMLElement;
        const title: HTMLElement = target.classList.contains('accordion-title')
            ? target
            : target.closest('.accordion-title');

        if (title.classList.contains('is-active')) {
            this.close(title.dataset.componentId);
        } else {
            this.open(title.dataset.componentId);
        }
    }

    open(id: string): void {
        const title = this.container.querySelector(`.accordion-title[data-component-id="${id}"]`);
        const content = this.container.querySelector(`.accordion-content[data-component-id="${id}"]`);

        if (!this.options.allowMultipleOpen) {
            this.closeAll();
        }

        title.classList.add('is-active');
        title.setAttribute('aria-selected', 'true');
        title.setAttribute('aria-expanded', 'true');

        content.classList.add('is-active');
        content.removeAttribute('inert');

        setTimeout(() => {
            if (this.options.scrollToTitle) title.scrollIntoView();
        }, 500)

        this.afterOpen(title.closest('.accordion').id);
    }

    close(id: string): void {
        const title = this.container.querySelector(`.accordion-title[data-component-id="${id}"]`);
        const content = this.container.querySelector(`.accordion-content[data-component-id="${id}"]`);

        title.classList.remove('is-active');
        title.setAttribute('aria-selected', 'false');
        title.setAttribute('aria-expanded', 'false');

        content.classList.remove('is-active');
        content.setAttribute('inert', 'true');

        this.afterClose(title.closest('.accordion').id);
    }

    closeAll() {
        this.titles.forEach(title => {
            this.close(title.dataset.componentId)
        })
    }

    handleKeydown(event: KeyboardEvent): void {
        const target = event.currentTarget;
        if (!(target instanceof Element)) return;
        let title: HTMLElement;

        switch (event.key) {
            case 'ArrowUp':
                title = (target.closest('.accordion').previousElementSibling)
                    ? target.closest('.accordion').previousElementSibling.querySelector('.accordion-title')
                    : null;
                break;

            case 'ArrowDown':
                title = (target.closest('.accordion').nextElementSibling)
                    ? target.closest('.accordion').nextElementSibling.querySelector('.accordion-title')
                    : null;
                break;

            case 'Home':
                title = this.titles[0];
                break;

            case 'End':
                title = this.titles[this.titles.length - 1];
                break;

            case 'Enter':
                this.toggle(event);
                break;

            case 'Escape':
                this.close(target.id)
                break;
        }

        if (title) title.focus();
    }

    public getDefaultOptions(options: Record<string, any> = {}) {
        const defaultOptions = {
            allowMultipleOpen: true,
            scrollToTitle: false,
        };
        return {
            ...super.getDefaultOptions(),
            ...defaultOptions,
            ...options,
        };
    }
}
